import { useEffect, useState } from "react";
import { track } from "../../../analytics";
import ComponentWrapper from "./ComponentWrapper";
import UnclaimedOrEmpty from "./UnclaimedOrEmpty";

export const ABOUT_SHOW_MORE_LIMIT = 1000;

const About = (props) => {
    const {
        about,
        background,
        unclaimed,
        name,
        split,
        expand,
        firmOrNetworkType,
        useWrapper,
        firmId,
        claimProfileUrl,
    } = props;

    const [showFullText, setShowFullText] = useState(false);

    useEffect(() => {
        if (expand !== undefined) {
            setShowFullText(expand);
        }
    }, [expand]);

    const toggleTextVisibility = () => {
        track(`${showFullText ? 'Closed' : 'Opened'} about`, {
            category:
                firmOrNetworkType === 'firm' ? 'Firm Profile' : 'Network Profile',
        });
        
        setShowFullText(!showFullText);
    };

    const renderAbout = () => (
        <>
            <div className={'mr-10 max-xs:mr-0 max-xs:mt-2 mb-4 max-xs:mb-0 grow-0 max-w-full basis-full m-0 '}>
                <h5 className={'text-2xl font-bold leading-[1.334] m-0 max-xs:text-center pb-4'}>About</h5>
                {!unclaimed && about ? (
                    <>
                        <p
                            className={
                                'text-[1.1rem] font-normal leading-6 m-0 whitespace-pre-line'
                            }
                            dangerouslySetInnerHTML={{
                                __html:
                                    showFullText || about.length <= ABOUT_SHOW_MORE_LIMIT
                                        ? about
                                        : `${about.substring(0, ABOUT_SHOW_MORE_LIMIT)}...`,
                            }}
                        />

                        {about.length > ABOUT_SHOW_MORE_LIMIT && !split && (
                            <button
                                type={'button'}
                                className={
                                    'max-xs:focus:outline-none max-xs:focus:bg-transparent border-0 rounded-3xl  p-0 text-[1.1rem] mt-[0.35rem] normal-case text-secondary-blue w-full ' +
                                    'inline-flex justify-start  bg-inherit leading-7 tracking-[1px] cursor-pointer hover:bg-blue-50'
                                }
                                data-test={'about-read-more'}
                                onClick={toggleTextVisibility}
                            >
                <span className={'w-full inline-flex'}>
                  <u>{showFullText ? 'Show less' : 'Read more'}</u>
                </span>
                            </button>
                        )}
                    </>
                ) : (
                    <UnclaimedOrEmpty
                        text={`${name} have not provided any information yet.`}
                        subtext={`Do you work at ${name}?`}
                        linkText="Add information"
                        unclaimed={unclaimed}
                        firmId={firmId}
                        claimProfileUrl={claimProfileUrl}
                        utmTerm="about"
                    />
                )}
            </div>
        </>
    );

    return (
        <div
            id="about"
            className={`m-0 pt-6 max-xs:pt-0 max-xs:mt-5 box-border ${background ? 'bg-pale-mint-green' : ''}`}
        >
            {useWrapper ? (
                <ComponentWrapper>{renderAbout()}</ComponentWrapper>
            ) : (
                renderAbout()
            )}
        </div>
    );
};

export default About;
